import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app/layout/App'
import './index.css'
import { initKeycloak } from './config/keycloak'

const root = ReactDOM.createRoot(document.getElementById('root')!)

initKeycloak(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
})